export const copyWith = <T extends object>(original: T, fields: Partial<T>): T => ({
  ...original,
  ...fields,
});

const withNullsRemoved = <T extends object>(
  object: T,
): { [K in keyof T]: NonNullable<T[K]> | undefined } => {
  const entries = Object.entries(object);

  return Object.fromEntries(
    entries.filter(([_, value]: [string, unknown]): boolean => value !== null),
  ) as {
    [K in keyof T]: NonNullable<T[K]> | undefined;
  };
};

export const copyWithNullsRemoved = <T extends object>(
  original: T,
  fields: NonNullable<Partial<T>>,
): T => {
  return copyWith(original, withNullsRemoved(fields));
};
